/**
 * Placement Bids V2 bulk-bid rules.
 * Min bid is always 0; resulting bids are always rounded to whole numbers.
 * Values are percentages (not currency).
 */

export const PLACEMENT_BIDS_V2_MIN_BID = 0;
export const PLACEMENT_BIDS_V2_FRACTION_DIGITS = 0;
export const PLACEMENT_BIDS_V2_UNIT = "%";

export function roundPlacementBid(value) {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return null;
  return Math.round(numeric);
}

/**
 * Rules object for BulkAdjustBidModalV2 (Placement Bids V2 only).
 * minBid = 0, always integer rounding, unit = %.
 */
export function getPlacementBidsBidRules() {
  return {
    unit: PLACEMENT_BIDS_V2_UNIT,
    minBid: PLACEMENT_BIDS_V2_MIN_BID,
    fractionDigits: PLACEMENT_BIDS_V2_FRACTION_DIGITS,
    roundBid: roundPlacementBid,
  };
}
